/*
 * Public API Surface of ng2-signalr
 */

export { ISignalRConnection } from './lib/services/connection/i.signalr.connection';
export { SignalRConnectionMock } from './lib/services/testing/signalr.connection.mock';
export { SignalRConnectionMockManager } from './lib/services/testing/signalr.connection.mock.manager';
export { ConnectionStatus } from './lib/services/connection/connection.status';
export { ConnectionStatuses } from './lib/services/connection/connection.statuses';
export { BroadcastEventListener } from './lib/services/eventing/broadcast.event.listener';
export { SignalRConnection } from './lib/services/connection/signalr.connection';
export { IConnectionOptions } from './lib/services/connection/connection.options';
export { ConnectionTransport } from './lib/services/connection/connection.transport';
export { ConnectionTransports } from './lib/services/connection/connection.transports';
export { SignalR } from './lib/services/signalr';
export { SignalRConfiguration } from './lib/services/signalr.configuration';
export { SignalRModule } from './lib/modules/signalr-module';

